/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { put } from 'redux-saga/effects'
import _ from 'lodash'

// import { fetchUser } from 'Redux/actions/user'

function* onTokenUpdate(action) {
  const failedAction = _.get(action, 'meta.action', null)

  const accessToken = _.get(action, 'payload.AccessToken', null)

  if (accessToken) {
    localStorage.setItem('access', accessToken)
  }

  if (failedAction) {
    yield put(failedAction)
  } else {
    // yield put(fetchUser())
  }

  yield true
}

export default onTokenUpdate
